// src/routes/ProtectedRoute.tsx
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import FullScreenLoader from "../components/ui/FullScreenLoader";

export default function ProtectedRoute() {
  const { loading, user, profile } = useAuth();

  // Mientras Auth/Perfil aún no resolvieron, mostramos la animación
  if (loading || typeof user === "undefined" || typeof profile === "undefined") {
    return <FullScreenLoader />;
  }

  // Sin sesión o perfil inactivo -> login
  if (!user || !profile?.isActive) {
    return <Navigate to="/login" replace />;
  }

  // Ok, deja pasar a las rutas hijas
  return <Outlet />;
}
